import { createEntityFilterConfig } from '../../factories/create-entity-filter-config';
import { STATIC_FILTER_ENTITY_TYPES } from '@shared/features/views/components/entities-filters/config';
import stageApi from '@src/features/programs/pages/create/services/stage-api';
import { StageFilterOptionItem } from './filter-option-item';

export const stageFilterConfig = createEntityFilterConfig({
  entityType: STATIC_FILTER_ENTITY_TYPES.stage,
  facetName: 'stage',
  fetchInfiniteData: stageApi.useFetchInfinite,
  getValue: (item) => String(item.id),
  renderItem: StageFilterOptionItem,
});
